import { State } from '../../store';

// Не должен использоваться в виджетах
const getDataCarsRelated = (state: State) => state.carsRelated.data;

export default getDataCarsRelated;
